import styles from '@/styles/About.module.css'
import Head from 'next/head'
import Image from 'next/image'
import dynamic from 'next/dynamic'
import HomeImage from '/public/img/Home.webp'
import { useTranslation } from 'react-i18next'

const Grill = dynamic(() => import('../components/Grill'))

const kebab = () => {
  const { t } = useTranslation()

  const generateMissingImage = (width, height, alt) => {
    if (
      !width ||
      !height ||
      typeof width !== 'number' ||
      typeof height !== 'number'
    ) {
      return (
        <Image
          src={HomeImage}
          className={styles.imageUrl}
          width={200}
          height={100}
          alt={alt || 'Image Not Available'}
          loading='lazy'
        />
      )
    }
    return (
      <Image
        src={`https://via.placeholder.com/${width}x${height}`}
        width={width}
        height={height}
        alt={alt || 'Image Not Available'}
        loading='lazy'
      />
    )
  }

  const itemList = [
    {
      name: 'Kebab',
      description: t(
        'Delight your taste buds with our succulent Kebab, featuring tender meat marinated in flavorful spices, grilled to perfection, and served with fresh salad and your choice of sauce.'
      ),
      image: '/rulle.webp',
      recipeIngredient: [
        'Assorted grilled kebab',
        'Salt and pepper to taste',
        'Pita bread',
        'Fresh vegetables',
        'Your choice of sauce (such as  mild sauce, garlic sauc or mix sauce)',
      ],
    },
    // other items
  ]

  return (
    <main className={styles.main}>
      <Head>
        <title>La Bambi Restaurang - Grill Meny</title>
        <meta
          name='description'
          content='Upplev smaksensationerna av sommarens grillfest med våra utsökta grillrätter. Från klassiska hamburgare, lövstek och Schnitzel till innovativa vegetariska alternativ, vi har något för alla grillälskare.'
        />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'ItemList',
              itemListElement: itemList.map((item, index) => ({
                '@type': 'ListItem',
                position: index + 1,
                item: {
                  '@type': 'Recipe',
                  name: item.name,
                  image: `/public${item.image}`, // Fix for image URL
                  description: item.description,
                  recipeIngredient: item.recipeIngredient,
                },
              })),
            }),
          }}
        />
      </Head>
      <Grill />
    </main>
  )
}

export default kebab
